import { render, staticRenderFns } from "./D005.vue?vue&type=template&id=bd81e26e&scoped=true&"
import script from "./D005.vue?vue&type=script&lang=js&"
export * from "./D005.vue?vue&type=script&lang=js&"
import style0 from "./D005.vue?vue&type=style&index=0&id=bd81e26e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd81e26e",
  null
  
)

export default component.exports